import PropTypes from "prop-types";
import { useState } from "react";
import { motion } from "framer-motion";
import Forms, { DEFAULT_FORM_ID } from "@/components/templateParts/Footer/Forms/Forms";
import useStore from "@/hooks/useStore";
import "./styles.scss";
import clsx from "clsx";
import { SubmitButton } from "@/components/utils/SubmitButton";
import { CONTACT_ID } from "@/utils/appConstants";

/* #META
 {
  "NAME": "Contact Form",
  "CLASSNAME": "contact-form-section",
  "URL": "http://nicasource.local"
 }
#ENDMETA */

const ContactForm = ({ data }) => {
  const { contact_form_title } = data || {};
  const [selectedForm, setSelectedForm] = useState(DEFAULT_FORM_ID);
  const { acfOptions } = useStore();
  const siteOptions = acfOptions();
  const { footer_info: footerInfo } = siteOptions;

  const { contact_forms: contactForms } = footerInfo || {};

  return (
    <section className="contact-form-section bg-darkGrayRevamp">
      <div className="contact-form-container container-revamp flex flex-col gap-6 py-10 lg:py-20 xl:px-0">
        {contact_form_title && <div dangerouslySetInnerHTML={{ __html: contact_form_title }} />}

        {contactForms && (
          <div
            id={CONTACT_ID}
            className="justify-center items-end h-auto flex flex-col gap-6 w-full"
          >
            <div className="w-full">
              {contactForms?.length && (
                <div className="flex items-start gap-6 flex-row">
                  {contactForms.map((form, index) => {
                    const formId = Number(form?.form_id ?? DEFAULT_FORM_ID);
                    const isActive = formId === selectedForm;

                    return (
                      <SubmitButton
                        action={() => setSelectedForm(formId)}
                        key={index}
                        name={form.form_title}
                        className={clsx(
                          "form-images-button text-honey border-b-2 transition-all duration-300",
                          isActive
                            ? "border-b-honey font-bold pointer-events-none"
                            : "border-b-transparent hover:border-b-honey focus:border-b-honey"
                        )}
                      />
                    );
                  })}
                </div>
              )}
            </div>

            {Boolean(selectedForm) && (
              <motion.div
                key={selectedForm}
                initial={{ opacity: 0, x: 20 }}
                animate={{ opacity: 1, x: 0 }}
                transition={{ duration: 0.5, ease: "easeInOut" }}
                className="w-full"
              >
                <Forms formId={selectedForm} />
              </motion.div>
            )}
          </div>
        )}
      </div>
    </section>
  );
};

ContactForm.propTypes = {
  data: PropTypes.shape({
    contact_form_title: PropTypes.string,
  }),
};

export default ContactForm;
